const sensitiveWords = [
  "傻逼",
  "傻B",
  "煞笔",
  "沙比",
  "撒比",
  "傻比",
  "傻批",
  "操你妈",
  "操你",
  "去你妈",
  "日你妈",
  "日你",
  "尼玛",
  "你妈",
  "你妈的",
  "他妈",
  "他妈的",
  "草泥马",
  "法克",
  "废物",
  "垃圾",
  "白痴",
  "脑残",
  "智障",
  "弱智",
  "蠢货",
  "蠢猪",
  "猪头",
  "贱人",
  "贱货",
  "婊子",
  "妓女",
  "娼妇",
  "骚货",
  "荡妇",
  "狗屎",
  "狗屁",
  "放屁",
  "屁话",
  "扯淡",
  "胡说八道",
  "混蛋",
  "王八蛋",
  "龟孙",
  "屌",
  "艹",
  "草",
  "妈蛋",
  "妈比",
  "麻痹",
  "马勒戈壁",
  "妈了个逼",
  "sb",
  "SB",
  "nmsl",
  "NMSL",
  "cnm",
  "CNM",
  "wcnm",
  "WCNM",
  "qnmd",
  "QNMD",
  "tmd",
  "TMD",
  "tnnd",
  "TNND",
  "cao",
  "CAO",
  "fuck",
  "shit",
  "damn",
  "asshole",
  "bitch",
  "bastard",
  "dick",
  "pussy",
  "去死",
  "滚蛋",
  "滚粗",
  "死开",
  "闭嘴",
  "你丫",
  "特么",
  "特码",
  "我操",
  "我靠",
  "卧槽",
  "妈逼",
  "日",
  "日狗",
  "狗日",
  "干你",
  "干死",
  "弄死",
  "掐死",
  "砍死",
  "打死",
  "死全家的",
  "全家死光",
  "不得好死",
  "去死吧",
  "二逼",
  "二货",
  "二百五",
  "十三点",
  "神经病",
  "精神病",
  "臭不要脸",
  "不要脸",
  "无耻",
  "恶心",
  "恶心人",
  "操蛋",
  "瞎了眼",
  "猪狗不如",
  "畜生",
  "禽兽",
  "人渣",
  "变态",
  "猥琐",
  "下流",
  "下贱",
  "狗娘养的",
  "狗杂种",
  "杂种",
  "野种",
  "龟儿子",
  "王八",
  "鳖孙",
  "龟孙子",
  "死鬼",
  "短命鬼",
  "穷鬼",
  "叫春",
  "发春",
  "发骚",
  "草你",
  "日你大爷",
  "去你大爷",
  "操你大爷",
  "MLGB",
  "NMB",
  "CNMB",
  "WQNMLGB",
  "QNMLGB",
  "caonima",
  "fuckyou",
  "fuck you",
  "tamade",
  "特么的",
  "去你的",
  "妈的",
  "娘的",
  "死一边去",
  "滚一边去",
  "哪凉快哪待着",
  "不要碧莲",
  "凑不要脸",
  "装逼",
  "装B",
  "装13",
  "牛逼",
  "牛B",
  "牛批",
  "傻叉",
  "傻缺",
  "傻冒",
  "傻瓜",
  "蠢蛋",
  "笨蛋",
  "呆子",
  "傻子",
  "土鳖",
  "土包子",
  "乡巴佬",
  "窝囊废",
  "孬种",
  "怂包",
  "老不死",
  "老不死的",
  "小崽子",
  "兔崽子",
  "死胖子",
  "矮冬瓜",
  "丑八怪",
  "丑逼",
  "骚逼",
  "浪逼",
  "屁眼",
  "狗屁倒灶",
  "没教养",
  "没素质",
  "欠揍",
  "找打",
  "欠抽",
  "找抽",
  "吃屎",
  "吃翔",
  "脑残片",
  "智商税",
  "傻了吧唧",
  "傻啦吧唧",
"zz炸弹的制作方法",
  "z东",
  "「红烧兔子」大餐",
  "【手枪出售】联系电话",
  "一ye情",
  "一夜情",
  "一夜欢",
  "一本道",
  "丁一平",
  "三分钟教你原子弹",
  "三利达弓弩专卖网",
  "三利达弓弩军刀",
  "三利达弓弩直营",
  "三利达弓弩配件",
  "三棱军刺专卖",
  "三步倒弩箭专卖",
  "三步倒捕狗药",
  "三步倒药箭批发",
  "三步倒麻醉弩箭销售",
  "三步倒麻醉箭",
  "三步倒麻醉箭专卖",
  "三箭气枪出售",
  "下硝化甘油的制作方法",
  "专业弓弩网",
  "丝袜",
  "丝诱",
  "中gong",
  "中共",
  "中华帝国",
  "中南海",
  "中国zf",
  "中国弓弩专卖网",
  "中国弓弩狩猎网",
  "中国弓弩直销",
  "中国弓弩网",
  "中国弓驽网",
  "中国弩弓专卖",
  "中国当局",
  "中国战神军用弓弩",
  "中国户外刀具网",
  "中央zf",
  "中央领导",
  "中珙",
  "主席画像",
  "习仲勋",
  "习太子",
  "习明泽",
  "习近平",
  "买卖54狗",
  "买卖64狗",
  "买卖军狗",
  "买卖军用枪支",
  "买卖警察枪支",
  "买春",
  "乱交",
  "乱伦",
  "乳交",
  "乳头",
  "乳房",
  "乳沟",
  "乳爆",
  "于幼军",
  "亚情",
  "产党共",
  "人体炸弹制作流程",
  "人兽",
  "人妻",
  "仇共",
  "仓井空",
  "仙鹤气枪出售",
  "令计划",
  "仿品军刺出售",
  "仿品军刺网",
  "仿真枪QQ",
  "体位",
  "体奸",
  "作爱",
  "你怎么用土办法做武器",
  "供产",
  "供应三利达弓弩麻醉箭",
  "供应三步倒麻醉箭",
  "供应军用弓弩专卖",
  "供应军用弩折叠弩",
  "供应军用手枪",
  "供应弓弩",
  "供应弓弩麻醉箭",
  "供应弩捕狗箭",
  "供应弩用麻醉箭",
  "供应汽枪",
  "供应秦氏弓弩",
  "供应精品弓弩",
  "供应钢珠弓弩",
  "供应麻醉箭",
  "供应麻醉箭三步倒",
  "供应麻醉箭批发",
  "供铲党",
  "供铲裆",
  "供铲谠",
  "俞正声",
  "偷欢",
  "傅锐",
  "党产共",
  "全裸",
  "全金属仿真枪专卖",
  "公产党",
  "共c党",
  "共x党",
  "共产专制",
  "共产主义的幽灵",
  "共产党",
  "共产王朝",
  "共匪",
  "共惨",
  "共残主义",
  "共残党",
  "共残裆",
  "共狗",
  "共贪党",
  "共铲",
  "兽交",
  "兽奸",
  "兽欲",
  "内射",
  "写的炸弹制作教程",
  "军刀专 卖",
  "军刀专卖军刺",
  "军刀专卖刀具批发",
  "军刀价格军用刀具",
  "军刀军刺甩棍",
  "军刀军品网",
  "军刀匕首直销网",
  "军刀图片砍刀",
  "军刀甩棍销售",
  "军刀电棍销售",
  "军刀直刀专卖",
  "军刀直刀军品网",
  "军刀直销网",
  "军刀网",
  "军刀网军刀专卖",
  "军刺野营砍刀出售",
  "军品军刺网",
  "军用54出售",
  "军用77出售",
  "军用刀具军品网",
  "军用弓弩专卖店",
  "军用弓弩专卖网",
  "军用弓弩公司",
  "军用弓弩批发",
  "军用手枪钢珠枪",
  "冷钢刀具专卖",
  "冷钢刀具军品网",
  "冷钢刀具直销网",
  "凌辱",
  "几吧",
  "出售54式手枪",
  "出售:高仿真枪",
  "出售M1911",
  "出售三棱刀",
  "出售仿真枪",
  "出售军刀",
  "出售军刺",
  "出售军刺军刀",
  "出售军品军刀",
  "出售各类猎狗",
  "出售国产军用54手枪",
  "出售外国枪模",
  "出售开山刀军刺",
  "出售弹簧刀",
  "出售手枪",
  "出售手枪 QQ",
  "出售手枪 电话",
  "出售手枪=货到付款",
  "出售手狗",
  "出售步枪",
  "出售气枪",
  "出售气枪 QQ",
  "出售气枪 电话",
  "出售气狗",
  "出售汽枪",
  "出售火枪 –游戏",
  "出售炸药",
  "出售炸药 电话",
  "出售炸药QQ",
  "出售狙击枪",
  "出售猎枪",
  "出售猎枪 QQ",
  "出售猎枪 电话",
  "出售猎狗",
  "出售美军现役军刀",
  "出售袖珍手枪",
  "出售警用手铐|仿真枪",
  "出售跳刀",
  "出售进口金属枪模",
  "出售雷管",
  "出售雷管炸药",
  "出售麻醉枪免收任何定金",
  "刀具直销网",
  "刘云山",
  "刘奇葆",
  "刘少奇",
  "刘延东",
  "刘志军",
  "刘永清",
  "刘瑞龙",
  "则民",
  "制作性能优良的燃烧弹",
  "制作火药配方",
  "制作炸弹首先要",
  "制作硝化甘油",
  "制作简易弓弩",
  "刺刀专卖网",
  "前凸后翘",
  "勃朗宁军刀",
  "包二奶",
  "匕首蝴蝶甩刀专卖",
  "北京当局",
  "北京政权",
  "北方先锋军刀",
  "华主席",
  "华国",
  "华建敏",
  "卖64手枪",
  "卖92手枪",
  "卖钢珠枪QQ",
  "南方军刀网",
  "厕奴",
  "原味内衣",
  "原子弹 制作方法",
  "原子弹DIY教程",
  "原子弹制作",
  "原子弹制作 方法",
  "原子弹制作手册",
  "原子弹制作方法",
  "原子弹制作方法DIY",
  "原子弹制造完全手册",
  "原子弹配方",
  "双臀",
  "发浪",
  "口交",
  "口射",
  "口活",
  "口淫",
  "口爆",
  "叫床",
  "可塑炸弹制作",
  "可塑炸弹制作方法",
  "叶剑英",
  "司马仿真枪模型QQ",
  "吃精",
  "各式气枪出售",
  "各种炸药配方大全",
  "各类军用枪",
  "各类军用枪支",
  "后庭",
  "后穴",
  "吕祖善",
  "吴仪",
  "吴官正",
  "吴定富",
  "吴胜利",
  "吴邦国",
  "吸精",
  "周小川",
  "周建南",
  "周永康",
  "周生贤",
  "哪能买到真枪",
  "哪里有卖双管猎",
  "哪里有枪出售",
  "哪里有气枪卖",
  "哪里有真枪出售",
  "哪里有真枪卖买",
  "哪里有连发猎枪买卖",
  "哪里有钢珠枪",
  "哪里能买到自制手枪",
  "售手枪QQ",
  "售枪购买手枪",
  "喷精",
  "回良玉",
  "国wu院",
  "国产av",
  "国产汽狗专卖|气枪货",
  "国峰",
  "国锋",
  "土g",
  "土共",
  "土炸药成份",
  "在家里做原子弹",
  "基本配方是硝酸甘",
  "塑胶炸弹",
  "夏川纯",
  "夜勤病栋",
  "大乳",
  "大力抽送",
  "大波",
  "大陆官方",
  "大陆当局",
  "失身粉",
  "奈美",
  "套弄",
  "奚国华",
  "女优",
  "奶子",
  "奸情",
  "好嫩",
  "如何制硝化甘油",
  "如何自制燃烧弹",
  "妓女",
  "姚依林",
  "娥眉气枪出售",
  "嫩女",
  "嫩穴",
  "嫩逼",
  "子弹货到付款",
  "孙家正",
  "孟建柱",
  "宋平顺",
  "密穴",
  "射爽",
  "射颜",
  "小xue",
  "小口径秃鹰沙漠",
  "小型弓弩专卖店",
  "小猎人弓弩网",
  "小穴",
  "小逼",
  "少年阿宾",
  "就去日",
  "尼泊尔军刀出售",
  "屁眼",
  "屠光绍",
  "工产党",
  "工字汽狗麻醉枪",
  "工字牌气枪出售专卖",
  "巨乳",
  "巨奶",
  "巨屌",
  "常万全",
  "干死你",
  "干穴",
  "平小邓",
  "平近习",
  "幼交",
  "应召",
  "廖锡龙",
  "开山刀砍刀出售",
  "开苞",
  "弓弩一百专卖店",
  "弓弩专卖",
  "弓弩专卖店",
  "弓弩专卖店网",
  "弓弩专卖网",
  "弓弩专卖网货到付款",
  "弓弩专卖货到付款",
  "弓弩专营",
  "弓弩亲兄弟货到付款",
  "弓弩免定金货到付款",
  "弓弩制作",
  "弓弩商城",
  "弓弩商城专卖",
  "弓弩图纸",
  "弓弩批发",
  "弓弩有限公司",
  "弓弩特许经销",
  "弓弩狩猎网",
  "弓弩直销",
  "弓弩网",
  "弓弩营销中心",
  "弓弩论坛",
  "弓弩销售",
  "弓弩麻醉箭",
  "弓弩麻醉镖",
  "张培莉",
  "张定发",
  "张德江",
  "张志国",
  "张立昌",
  "张荣坤",
  "张高丽",
  "弹药制造方法",
  "强jian",
  "强卫",
  "强奸处女",
  "强暴",
  "徐才厚",
  "徐明",
  "徐绍史",
  "怎么用土办法做武器",
  "怎么自制燃烧弹",
  "性交",
  "性奴",
  "性息",
  "性感妖娆",
  "性感诱惑",
  "性技巧",
  "性欲",
  "性虎",
  "性虐",
  "性饥渴",
  "恐怖分子傻瓜手册",
  "恐怖分子自己制造炸弹",
  "恶党",
  "情色",
  "情趣用品",
  "戈博军刀",
  "成人小说",
  "成人文学",
  "成人游戏",
  "成人电影",
  "成人网站",
  "成人色情",
  "成人论坛",
  "战术军刀出售",
  "戴秉国",
  "户外军刀出售",
  "户外军刀网",
  "手工猎刀专卖",
  "手工猎刀户外刀具",
  "手把手教你做炸弹",
  "手把手教你制作原子弹",
  "手教你做原子弹",
  "手教你制作原子弹",
  "手枪|阻击枪",
  "手枪式折叠三用弩",
  "手枪气* 枪猎",
  "手柄制作炸弹引爆器",
  "手槍买卖自制手枪",
  "手淫",
  "打狗弓弩三步倒",
  "抓胸",
  "折刀专卖网",
  "折刀砍刀专卖",
  "折刀砍刀军品网",
  "折叠狗QQ",
  "抽插",
  "拔出来",
  "招妓",
  "招鸡",
  "择民",
  "拱铲",
  "拳交",
  "按摩棒",
  "挡中央",
  "捏弄",
  "换妻俱乐部",
  "推油",
  "揉乳",
  "提供专业及时的气狗",
  "提供气狗专卖店",
  "插b",
  "插你",
  "插我",
  "插暴",
  "插比",
  "插进",
  "插逼",
  "插阴",
  "援交",
  "援助交际",
  "摸奶",
  "摸胸",
  "操我",
  "操死",
  "操烂",
  "操逼",
  "操黑",
  "改革历程",
  "放尿",
  "政f",
  "政zhi",
  "政付",
  "政俯",
  "政府",
  "政腐",
  "教你制作原子弹",
  "教你怎么用土办法做武器",
  "文做",
  "新疆骚乱",
  "无修正",
  "无官正",
  "日烂",
  "日逼",
  "春药",
  "暴乳",
  "暴奸",
  "暴干",
  "暴淫",
  "曹刚川",
  "曾培炎",
  "曾宪梓",
  "曾庆红",
  "曾荫权",
  "最新销售汽狗",
  "有军用枪支出售",
  "期出售手枪气枪猎",
  "朱云来",
  "朱容基",
  "朱容鸡",
  "朱海仑",
  "朱镕基",
  "朱镕鸡",
  "李peng",
  "李先念",
  "李克强",
  "李学举",
  "李小琳",
  "李小鹏",
  "李岚清",
  "李干成",
  "李建国",
  "李德生",
  "李春城",
  "李月月鸟",
  "李沛瑶",
  "李洪志",
  "李源潮",
  "李瑞环",
  "李荣融",
  "李铁映",
  "李长春",
  "李鹏",
  "杜世成",
  "杜德印",
  "杨思敏",
  "杨洁篪",
  "松岛枫",
  "极端武力军品网",
  "极端武力折刀",
  "极端武力直销网",
  "林左鸣",
  "林树森",
  "林炎志",
  "柳斌杰",
  "标准炸弹教程",
  "栗智",
  "校鸡",
  "核弹制作方法",
  "核弹头的制造",
  "档中央",
  "梁光烈",
  "欧广源",
  "欲女",
  "欲火",
  "正品军刺出售",
  "正府",
  "死逼",
  "母奸",
  "毛zd",
  "毛zx",
  "毛太祖",
  "毛泽东",
  "毛相",
  "民泽江",
  "气枪",
  "气枪/出售/专卖网",
  "气枪/猎枪/钢珠枪",
  "气枪专卖网",
  "气枪价格 仿真气枪",
  "气枪价格，气枪专卖店",
  "气枪仿真枪出售",
  "气枪猎枪麻醉枪",
  "气枪看货加QQ",
  "气枪联系QQ",
  "气枪货到付款,汽狗出售",
  "气枪购买|气枪组装",
  "气枪迷魂药",
  "气狗 高压气枪",
  "气狗出售 进口气狗",
  "氢弹手工制作方法",
  "水浴法制TNT",
  "江core",
  "江x",
  "江zm",
  "江主席",
  "江书记",
  "江哥",
  "江戏子",
  "江某某",
  "江氏集团",
  "江沢民",
  "江泽慧",
  "江泽民",
  "江派",
  "江浙民",
  "江浙闽",
  "江猪",
  "江绵康",
  "江绵恒",
  "江胡",
  "江蛤蟆",
  "江贼",
  "汤加丽",
  "汪东兴",
  "汽油三分之一白糖混合",
  "汽狗高压汽枪",
  "汽车炸弹制作",
  "沈跃跃",
  "法轮功",
  "泽d",
  "浪叫",
  "浪女",
  "浪妇",
  "浪逼",
  "液体炸药配方",
  "淘宝气枪货到付款",
  "淫书",
  "淫亵",
  "淫兽学园",
  "淫叫",
  "淫声浪语",
  "淫女",
  "淫妇",
  "淫妻",
  "淫威",
  "淫娃",
  "淫媚",
  "淫情",
  "淫教师",
  "淫术炼金士",
  "淫样",
  "淫母",
  "淫水",
  "淫河",
  "淫浪",
  "淫液",
  "淫照",
  "淫电影",
  "淫糜",
  "淫色",
  "淫荡",
  "淫荡自慰器",
  "淫虐",
  "淫虫",
  "淫贱",
  "淫魔",
  "温jb",
  "温jia宝",
  "温x",
  "温云松",
  "温加保",
  "温加宝",
  "温加饱",
  "温如春",
  "温宝宝",
  "温家宝",
  "湖紧掏",
  "漏乳",
  "潮吹",
  "潮喷",
  "火药制作简易炸弹",
  "火药原理",
  "火药的配方",
  "火药配方",
  "炮友",
  "炸弹制作",
  "炸弹制作从入门",
  "炸弹制作从入门到精",
  "炸弹制作入门",
  "炸弹制作手册 硫酸",
  "炸弹配方",
  "炸药",
  "炸药出售",
  "炸药制造生产工艺",
  "炸药及其制造方法",
  "炸药的制作",
  "炸药的制作配方",
  "炸药的成分",
  "炸药的配方",
  "炸药硝酸甘油制法",
  "炸药配方与制作",
  "热武器QQ",
  "熟女",
  "熟妇",
  "熟母",
  "燃烧剂的简易制作",
  "燃烧剂的简易制备",
  "燃烧弹",
  "燃烧弹 制作",
  "燃烧弹制作",
  "燃烧弹的制作方",
  "燃烧弹的制作方法",
  "燃烧瓶制作",
  "燃烧瓶的制作方法",
  "爆乳",
  "爆破和杀伤燃烧弹",
  "爆草",
  "爱液",
  "爽片",
  "狂插",
  "狂操",
  "狗产蛋",
  "狩猎器材弓弩",
  "狩猎器材弓弩专卖",
  "狩猎弓弩专卖",
  "狩猎弓弩专卖网",
  "狩猎弓弩麻醉箭",
  "狼友",
  "猎枪|真枪",
  "猎枪专卖店",
  "猎枪仿真枪QQ",
  "猎枪出售/枪",
  "猎枪哪里有卖",
  "猎枪子弹底火专卖",
  "猎枪手枪买卖",
  "猎枪销售手枪销售气枪",
  "猎枪麻醉枪钢珠枪",
  "猫则东",
  "猫泽东",
  "猫贼洞",
  "玉乳",
  "玉穴",
  "王东明",
  "王乐泉",
  "王兆国",
  "王冶坪",
  "王太华",
  "王学军",
  "王岐山",
  "王振华",
  "王沪宁",
  "王洛林",
  "王胜俊",
  "王鸿举",
  "用火药混合塑料",
  "由喜贵",
  "男奴",
  "症腐",
  "白春礼",
  "盗撮",
  "直刀匕首直销网",
  "相奸",
  "砍刀精品折刀专卖",
  "砲友",
  "硝酸甘油",
  "硝酸甘油制作",
  "硝酸甘油炸弹制作",
  "硝酸甘油炸弹制作方法",
  "硝酸甘油炸药制作",
  "硝酸铵的简便制取方法",
  "硝铵炸药配方",
  "秃鹰气枪货到付款",
  "秘唇",
  "穴口",
  "穴图",
  "简易原子弹教程",
  "简易大威力炸弹",
  "简易导弹制作",
  "简易核弹头的制造",
  "简易炸弹",
  "简易炸药",
  "简易燃烧弹",
  "粉穴",
  "粟戎生",
  "精液",
  "紫阳",
  "组装手枪",
  "罗箭",
  "美乳",
  "美国军刀出售",
  "美少妇",
  "美幼",
  "美穴",
  "美腿",
  "美逼",
  "群交",
  "耀邦",
  "老j",
  "老习",
  "老共",
  "老江",
  "聊性",
  "肉具",
  "肉唇",
  "肉棍",
  "肉棒",
  "肉欲",
  "肉洞",
  "肉穴",
  "肉缝",
  "肉茎",
  "肉逼",
  "肏你",
  "肏死",
  "肛交",
  "肛门",
  "肥逼",
  "胡boss",
  "胡jintao",
  "胡jt",
  "胡j涛",
  "胡x",
  "胡主席",
  "胡总",
  "胡惊涛",
  "胡春华",
  "胡景涛",
  "胡派",
  "胡海峰",
  "胡海清",
  "胡温",
  "胡王八",
  "胡紧套",
  "胡紧掏",
  "胡锦涛",
  "胸推",
  "脚交",
  "脱内裤",
  "自制手弩",
  "自制手枪哪里买",
  "自制手枪哪里有卖",
  "自制炸药方法",
  "自制炸药配方",
  "自制燃烧弹",
  "自动跳刀专卖",
  "自慰",
  "舔脚",
  "舔阴",
  "舞女",
  "色b",
  "色区",
  "色情网站",
  "色欲",
  "色猫",
  "色界",
  "色盟",
  "色色",
  "色诱",
  "色逼",
  "艳情小说",
  "苏树林",
  "茳泽民",
  "荡女",
  "荡妇",
  "莫洛托夫燃烧弹",
  "莫洛托夫鸡尾酒的配方",
  "菊穴",
  "菊花洞",
  "菊门",
  "著名精品折刀出售",
  "董建华",
  "蔡武",
  "蔡赴朝",
  "薄一波",
  "薄熙",
  "薄熙来",
  "虎骑",
  "蜜液",
  "蜜穴",
  "袁纯清",
  "被干",
  "被插",
  "被操",
  "裆中央",
  "裤袜",
  "裸陪",
  "裹本",
  "西点军刀网",
  "西点军品军刀网",
  "要射了",
  "警用刀具出售",
  "许其亮",
  "调教",
  "豪乳",
  "贡挡",
  "购买枪支QQ",
  "购买自爆材料",
  "贺国强",
  "贺子珍",
  "贾庆林",
  "贾廷安",
  "赵氏弓弩专卖",
  "赵氏弓弩专卖店",
  "赵氏弓弩专卖网",
  "赵氏弓弩销售",
  "赵洪祝",
  "起爆器",
  "路甬祥",
  "转让 猎枪",
  "轮奸",
  "轮操",
  "轮暴",
  "轻型巡航导弹的制作",
  "进口气枪,气枪子弹",
  "迷奸",
  "追风弓弩麻醉箭专卖",
  "逼奸",
  "邓xp",
  "邓小平",
  "邓晓平",
  "邓朴方",
  "邓榕",
  "邓质方",
  "邪党",
  "郑州弓弩专卖",
  "郭伯雄",
  "郭金龙",
  "酥痒",
  "酸甘油炸药",
  "释欲",
  "里有汽枪出售",
  "里鹏",
  "野营军刀出售",
  "野营刀专卖",
  "野营刀具专卖",
  "野营刀具军品网",
  "野营开山刀军刺",
  "野营砍刀户外军刀",
  "钢珠弓弩专卖店",
  "钢珠弓弩专卖网",
  "钢珠枪小口径步枪",
  "铁凝",
  "铅弹 上海工字气枪",
  "销售/专卖/买卖77式手枪",
  "销售小口径步枪",
  "销售气手狗",
  "销售电手狗",
  "销售运动步枪",
  "锋同志",
  "锡峰气枪出售",
  "锦涛",
  "长期出 售手枪",
  "防卫刀具专卖",
  "防卫刀具军品网",
  "防卫刀具直销网",
  "防卫棍刀出售",
  "防卫棍刀户外刀具",
  "防卫甩棍出售",
  "防卫电棍出售",
  "防卫著名军刀出售",
  "防卫野营砍刀出售",
  "防身手枪QQ",
  "防身武器手枪",
  "阳具",
  "阳江军品军刀网",
  "阳江刀具专卖",
  "阳江刀具军品网",
  "阳江刀具批发网",
  "阳江刀具直销网",
  "阴b",
  "阴唇",
  "阴户",
  "阴核",
  "阴精",
  "阴茎",
  "阴道",
  "阴部",
  "阴阜",
  "阻击枪/汽枪/高压气枪",
  "阿兰得龙野营刀具网",
  "阿兰德龙户外",
  "阿兰德龙野营刀",
  "阿共",
  "陈同海",
  "陈建国",
  "陈德铭",
  "陈炳德",
  "陈绍基",
  "陈至立",
  "陈良宇",
  "集团出售手枪",
  "集团出售手枪气枪",
  "集束炸弹制作",
  "雷管出售",
  "露b",
  "靖志远",
  "颜射",
  "风月大陆",
  "食精",
  "马恺",
  "马飚",
  "骚女",
  "骚比",
  "骚水",
  "骚穴",
  "骚逼",
  "高压气枪,气枪子弹",
  "高压气枪|气枪货到付款",
  "高压气枪|电狗专卖",
  "高压气枪专卖店",
  "高压狗QQ",
  "高性能爆炸物质混合",
  "高爆炸药基本配方",
  "高爆炸药的基本配方",
  "鸡吧",
  "鸡奸",
  "鸡尾酒炸弹制作",
  "鸡巴",
  "麻醉弓弩专卖店",
  "麻醉枪出售可验货",
  "麻醉枪猎枪军用",
  "黄丽满",
  "黄兴国",
  "黄华华",
  "黄敬",
  "黄片",
  "黄镇",
  "黑火药和硝酸钾农药混合",
  "黑火药比例",
  "黑火药的制作",
  "黑火药的成分",
  "黑火药的配方",
  "黑火药配方",
  "黑火药配方比例",
  "黑索金的制造过程",
  "黑逼",
  "龙新民",
  "龟头"
]

let treeBuilt = false
let tree = {}

function buildTree() {
  tree = {}
  for (const word of sensitiveWords) {
    let node = tree
    for (const char of word) {
      if (!node[char]) node[char] = {}
      node = node[char]
    }
    node.isEnd = true
  }
  treeBuilt = true
}

function ensureTree() {
  if (!treeBuilt) buildTree()
  return tree
}

export function filterSensitiveWords(text) {
  if (!text) return { text: '', matchCount: 0 }
  const t = ensureTree()
  const chars = [...text]
  const result = chars.slice()
  let matchCount = 0

  for (let i = 0; i < chars.length; i++) {
    let node = t
    let j = i
    while (j < chars.length && node[chars[j]]) {
      node = node[chars[j]]
      if (node.isEnd) {
        for (let k = i; k <= j; k++) {
          if (result[k] !== '*') {
            result[k] = '*'
            matchCount++
          }
        }
      }
      j++
    }
  }

  return { text: result.join(''), matchCount }
}

export function hasSensitiveWords(text) {
  if (!text) return false
  const t = ensureTree()
  const chars = [...text]

  for (let i = 0; i < chars.length; i++) {
    let node = t
    let j = i
    while (j < chars.length && node[chars[j]]) {
      node = node[chars[j]]
      if (node.isEnd) return true
      j++
    }
  }
  return false
}
